declare global {
  interface Window {
    $sleek: any;
    SLEEK_PRODUCT_ID: number;
  }
}

const hideLauncher = () => {
  try {
    if (typeof window.$sleek?.hideButton === 'function') {
      window.$sleek.hideButton();
    }
  } catch {
    // SDK not ready or already torn down; safe to ignore.
  }
};

// The SDK re-shows its floating launcher on multiple lifecycle moments
// (init, popup open, popup close). Hooking every relevant event keeps the
// launcher hidden so the only entry point stays the header smiley button.
const SLEEK_EVENTS = [
  'sleek:init',
  'sleek:open',
  'sleek:close',
  'sleek:popup-open',
  'sleek:popup-close',
];
SLEEK_EVENTS.forEach((eventName) => {
  window.addEventListener(eventName, hideLauncher, false);
});

// Cover the case where the SDK was already initialized before this module
// registered its listeners (re-imports, hot reloads, very fast networks).
hideLauncher();

export const toggleSleek = (): void => {
  try {
    window.$sleek?.toggle?.();
  } catch {
    // No-op when the SDK has not finished loading yet.
  }
  // After toggling, re-hide the launcher in case the SDK re-renders it
  // before the close event fires.
  setTimeout(hideLauncher, 100);
  setTimeout(hideLauncher, 500);
  setTimeout(hideLauncher, 1500);
};

export {};
